import { render, staticRenderFns } from "./MatResult.vue?vue&type=template&id=f8d29b6e&scoped=true"
import script from "./MatResult.vue?vue&type=script&lang=js"
export * from "./MatResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d29b6e",
  null
  
)

export default component.exports